import { Injectable, Inject } from '@angular/core';
import { TranslationRepository } from '../../domain/repositories/translation.repository';
import { TRANSLATION_REPOSITORY_TOKEN } from '../../domain/tokens/injection.tokens';

/**
 * Application Use Case
 * Caso de uso para traducir roles
 */
@Injectable({
  providedIn: 'root'
})
export class TranslateRoleUseCase {
  
  constructor(@Inject(TRANSLATION_REPOSITORY_TOKEN) private translationRepository: TranslationRepository) {}

  /**
   * Traduce un nombre de rol al idioma especificado
   */
  async execute(roleName: string, language: string = 'es'): Promise<string> {
    if (!roleName) {
      return roleName;
    }

    try {
      return await this.translationRepository.getRoleTranslation(roleName, language);
    } catch (error) {
      console.warn(`Error translating role ${roleName}:`, error);
      return roleName; // Fallback al nombre original
    }
  }

  /**
   * Traduce múltiples roles
   */
  async translateRoles(roles: any[], language: string = 'es'): Promise<any[]> {
    const translatedRoles = await Promise.all(
      roles.map(async (role) => ({
        ...role,
        roleName: await this.execute(role.roleName, language),
        description: await this.execute(role.roleName, language)
      }))
    );

    return translatedRoles;
  }
}
